// Internal
import type { ShippingCallbackErrorMapping } from './types';

/**
 * Those errors are related to the Shipping and Callback feature for
 * the smart button integration. See:
 * {@link https://developer.paypal.com/api/rest/reference/orders/v2/errors/}
 * {@link https://developer.paypal.com/beta/accelerated-checkout/#link-errors}
 *
 * In an ideal scenario, the sdk would send us the error code,
 * but they are sending the error message instead. This should be revisited
 * when we can have the sdk send the error codes.
 */
const SHIPPING_CALLBACK_ERROR_MAPPING: ShippingCallbackErrorMapping = {
  DEFAULT: 'fieldErrors.shippingMethod.patchOrderFailed',
  'Order could not be patched': 'fieldErrors.shippingMethod.patchOrderFailed',
  "Part of your order isn't available at this store.":
    'fieldErrors.shippingMethod.storeUnavailable',
  'The shipping method you chose is unavailable. To continue, choose another way to get your order.':
    'fieldErrors.shippingMethod.methodUnavailable',
  "Your order can't be shipped to this address.":
    'fieldErrors.shipping.addressReject',
  "Your order can't be shipped to this country.":
    'fieldErrors.shipping.countryReject',
  "Your order can't be shipped to this state.":
    'fieldErrors.shipping.stateReject',
  "Your order can't be shipped to this zip.": 'fieldErrors.shipping.zipReject',
};

const SERVER_SIDE_SHIPPING_CALLBACK_ERROR_MAPPING: ShippingCallbackErrorMapping =
  {
    ADDRESS_ERROR: 'fieldErrors.shipping.addressReject',
    COUNTRY_ERROR: 'fieldErrors.shipping.countryReject',
    DEFAULT: 'fieldErrors.shippingMethod.patchOrderFailed',
    METHOD_UNAVAILABLE: 'fieldErrors.shippingMethod.methodUnavailable',
    STATE_ERROR: 'fieldErrors.shipping.stateReject',
    STORE_UNAVAILABLE: 'fieldErrors.shippingMethod.storeUnavailable',
    ZIP_ERROR: 'fieldErrors.shipping.zipReject',
  };

export {
  SHIPPING_CALLBACK_ERROR_MAPPING,
  SERVER_SIDE_SHIPPING_CALLBACK_ERROR_MAPPING,
};
